import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import UsersManagement from './components/UsersManagement';
import AIAgents from './components/AIAgents';
import AIAgentDetail from './components/AIAgentDetail';

import Feedbacks from './components/Feedbacks';
import Questions from './components/Questions';
import Automations from './components/Automations';
import Profile from './components/Profile';
import Analytics from './components/Analytics';
import AnalyticsDetails from './components/AnalyticsDetails';
import ErrorDetails from './components/ErrorDetails';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UsersManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-agents"
            element={
              <ProtectedRoute>
                <AIAgents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-agents/:id"
            element={
              <ProtectedRoute>
                <AIAgentDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/automations"
            element={
              <ProtectedRoute>
                <Automations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedbacks"
            element={
              <ProtectedRoute>
                <Feedbacks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/questions"
            element={
              <ProtectedRoute>
                <Questions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/details"
            element={
              <ProtectedRoute>
                <AnalyticsDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/errors"
            element={
              <ProtectedRoute>
                <ErrorDetails />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
